<template>
    <div class="mb-box" ref="mbBox">
        <router-link
            :to="{
                name: generateName(item.type),
                params: { type: item.type.toUpperCase(), id: item._id, slug: getSlug(item.url), from: item.breadcrumbs ? item.breadcrumbs[0].title : ''},
            }"
            custom
            v-slot="{ href, navigate }"

        >   
            <a v-if="isAgePrevent" @click="clickHandle" class="mb-box__item">
                <div class="mb-box__icon mb-box__info" v-if="showInfo" @click.prevent.stop="toggleModalInfo">
                    <IconInfoActive v-if="isInfoHover"></IconInfoActive>
                    <IconInfo v-else></IconInfo>
                </div>

                <div 
                    v-if="showFavorite" 
                    class="mb-box__icon mb-box__favorite" 
                >
                    <IconFavoriteActive v-if="isFavorite || isSetFavorite" @click.prevent.stop="removeFavorite()"></IconFavoriteActive>
                    <IconFavorite v-else @click.prevent.stop="addFavorite()"></IconFavorite>
                </div>

                <figure class="mb-box__img" :style="{ 'border-color': color }">
                    <Image :image="item.image" :width="440" :height="248"></Image>
                    <span class="mb-box__target-age" v-if="targetAge">{{ targetAge }}</span>
                    <Labels v-if="item.label" :labels="item.label" :id="item._id"></Labels>
                </figure>

                <h2 class="mb-box__title">{{ item.title }}</h2>                    
            </a>
            
            <a
                v-else
                :href="href"
                @click="navigate"
                class="mb-box__item"
            >
                <div class="mb-box__icon mb-box__info" v-if="showInfo" @click.prevent.stop="toggleModalInfo">
                    <IconInfoActive v-if="isInfoHover"></IconInfoActive>
                    <IconInfo v-else></IconInfo>
                </div>

                <div 
                    v-if="showFavorite" 
                    class="mb-box__icon mb-box__favorite" 
                >
                    <IconFavoriteActive v-if="isFavorite || isSetFavorite" @click.prevent.stop="removeFavorite()"></IconFavoriteActive>
                    <IconFavorite v-else @click.prevent.stop="addFavorite()"></IconFavorite>
                </div>

                <figure class="mb-box__img" :style="{ 'border-color': color }">
                    <Image :image="item.image" :width="440" :height="248"></Image>
                    <span class="mb-box__target-age" v-if="targetAge">{{ targetAge }}</span>
                    <Labels v-if="item.label" :labels="item.label" :id="item._id"></Labels>
                </figure>

                <h2 class="mb-box__title">{{ item.title }}</h2>
            </a>
        </router-link>

        <transition name="fade" appear>
            <ModalDetails
                v-if="isModalInfo"
                @toggleModalInfo="toggleModalInfo"
                :image="item.image"
                :title="item.title"
                :lead="item.lead"
                :color="color"
                :targetAge="targetAge"
            ></ModalDetails>
        </transition>

        <transition name="fade" appear>
            <ModalSelectSubProfile
                v-if="isModalFavorites"
                @selectSubprofile="selectSubprofile"
                @toggleModalFavorites="toggleModalFavorites"
                :subProfilesList="subProfilesList"
                :isFavorite="isFavorite"
            ></ModalSelectSubProfile>
        </transition>

        <transition name="fade" appear>
            <ModalUnlock 
                v-if="isModalUnlock" 
                :itemId="item._id" 
                :path="path"
                @closeModalUnlock="closeModalUnlock">
            </ModalUnlock>
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import Image from "../elements/Image.vue";
import IconInfo from "../elements/icons/IconInfo.vue";
import IconInfoActive from "../elements/icons/IconInfoActive.vue";
import IconFavorite from "../elements/icons/IconFavorite.vue";
import IconFavoriteActive from "../elements/icons/IconFavoriteActive.vue";
import Labels from "../elements/Labels.vue";
import ModalSelectSubProfile from "../modals/ModalSelectSubProfile.vue";
import ModalDetails from "../modals/ModalDetails.vue";
import ModalUnlock from "../modals/ModalUnlock.vue";
import globalDataLayer from '../../mixins/globalDataLayer';

const toast = useToast()

export default {
    name: "MbBox",
    props: {
        item: {
            type: Object,
            required: true,
        },
        showFavorite: {
            type: Boolean,
            default: true
        },
        pageType: {
            type: String
        },
        selectedSubProfile: {
            type: String,
            default: ''
        },
        isFavorite: {
            type: Boolean,
            default: false
        },
        showInfo: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isModalInfo: false,
            isModalFavorites: false,
            isInfoHover: false,
            isModalUnlock: false,
            // isModalSelectSubprofile: false,
            subprofileSelectedByParent: '',
            FAVORITE_ADD: '/api/krainaabc/subprofile/favorite-add?device=www',
            FAVORITE_REMOVE: '/api/krainaabc/subprofile/favorite-remove?device=www', 
            isSetFavorite: false
        };
    },
    components: {
        Image,
        IconInfo,
        IconInfoActive,
        IconFavorite,
        IconFavoriteActive,
        ModalDetails,
        ModalSelectSubProfile,
        ModalUnlock,
        Labels
    },
    mixins: [globalDataLayer],
    computed: {
        color() {
            let color = this.$store.getters.getCategoryColor;

            if(color) {
                return color;
            } else if (this.item.breadcrumbs && this.item.breadcrumbs[0] && this.item.breadcrumbs[0].color) {
                return this.item.breadcrumbs[0].color;
            }

            return null;
        },
        userData() {
            return this.$store.getters.getUserData;
        },
        globalUserData() {
            return this.$store.getters.getGlobalUserData;
        },
        activeSubProfile() {
            return this.$store.getters.getActiveSubProfile;
        },
        subProfilesList() {
            return this.$store.getters.getSubProfiles;
        },
        isLogged() {
            return this.$store.getters.isLoggedIn;
        },
        targetAge() {
            if(this.isLogged) {
                if(this.item.target_age_three_six && this.item.target_age_seven_ten) {
                    return '3-10';
                } else if(this.item.target_age_seven_ten) {
                    return '7-10';
                } else if(this.item.target_age_three_six) {
                    return '3-6';                    
                } else {
                    return null;
                }
            }
            return null
        },
        isAgePrevent() {
            if(
                this.isLogged && 
                this.activeSubProfile && 
                this.activeSubProfile.age < 7 && 
                this.item.target_age_three_six === false &&
                this.item.target_age_seven_ten === true &&
                !this.isFavorite
            ) {
                return true;
            } 

            return false;
        },
        path() {
            return this.$route.fullPath;
        },
        category() {
            if(this.item && this.item.breadcrumbs && this.item.breadcrumbs[0] && this.item.breadcrumbs[0].title) {
                return this.item.breadcrumbs[0].title;
            }
            return null;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        },
        getIsModalUnlock() {
            return this.$store.getters.getModalUnlock;
        }, 
    },
    watch: {
        subprofileSelectedByParent(value) {
            if(value) {
                const data = {};
                data['src'] = 'krainaabc';
                data['id'] = this.item._id;
                data['subProfile_id'] = value;

                let endpoint = this.isFavorite ? this.FAVORITE_REMOVE : this.FAVORITE_ADD;

                axios
                    .post(endpoint, data)
                    .then(() => {
                        if(this.isFavorite) {
                            toast.success("Usunięto z ulubionych");
                        } else {
                            toast.success("Dodano do ulubionych");
                            this.addToFavourite(this.item.title, this.category);
                        }

                        this.$store.dispatch("favorites", null);
                    })
                    .catch(function(error) {
                        toast.error("Dodanie do ulubionych nie powiodło się");
                        console.log(error);
                    });                 
            }
        },
        isAgePrevent(newValue) {
            if(!newValue) {
                this.isModalUnlock = false;
                this.$store.dispatch("changeModalBackdrop", false);
            }
        },
        getIsModalUnlock(newValue) {
            console.log(`mbbox getIsModalUnlock ${newValue}`);
        }
    },
    methods: {
        addFavorite() {
            const data = {};
            data['src'] = 'krainaabc';
            data['id'] = this.item._id;

            if (this.isLogged) {
                if(this.selectedSubProfile) {  
                    data['subProfile_id'] = this.selectedSubProfile;

                    axios
                        .post(this.FAVORITE_ADD, data)
                        .then(() => {
                            this.addToFavourite(this.item.title, this.category);
                            this.$store.dispatch("activeSubProfile");
                            toast.success("Dodano do ulubionych");
                        })
                        .catch(function(error) {
                            toast.error("Dodanie do ulubionych nie powiodło się");
                            console.log(error);
                        });  
                } else if(this.activeSubProfile && this.activeSubProfile._id) {
                    if(this.isAgePrevent) {
                        this.isModalUnlock = true;
                        this.$store.dispatch("changeModalBackdrop", true);
                    } else {
                        data['subProfile_id'] = this.activeSubProfile._id;

                        axios
                            .post(this.FAVORITE_ADD, data)
                            .then(() => {
                                this.addToFavourite(this.item.title, this.category);
                                this.$store.dispatch("activeSubProfile");   
                                toast.success("Dodano do ulubionych");
                                this.isSetFavorite = true;
                            })
                            .catch(function(error) {
                                toast.error("Dodanie do ulubionych nie powiodło się");
                                console.log(error);
                            });   
                    }
                } else if (this.subProfilesList && this.subProfilesList.length) {
                    this.toggleModalFavorites();
                } else {
                    this.$store.dispatch("changeModalCreateProfilState");
                    this.$store.dispatch("changeModalBackdrop", false);
                }

                window.gemius_event('_action_', this.gemiusIdentifier, 'button=favorites-like', `SCREEN_HIT=${this.$route.name}`, `NAME=${this.item.title}`);
            } else {
                this.$store.dispatch("changeModalAccessState");
                this.$store.dispatch("changeModalBackdrop", true);
            }
        },
        removeFavorite() {
            const data = {};
            data['src'] = 'krainaabc';
            data['id'] = this.item._id;

            if(this.selectedSubProfile) {
                data['subProfile_id'] = this.selectedSubProfile;
                        
                axios
                    .post(this.FAVORITE_REMOVE, data)
                    .then(() => {
                        this.$store.dispatch("favorites", { id: this.selectedSubProfile });        
                        toast.success("Usunięto z ulubionych");            
                    })
                    .catch(function(error) {
                        console.log(error);
                        toast.error("Usunięcie z ulubionych nie powiodło się");
                    })

            } else if(this.activeSubProfile && this.activeSubProfile._id) {

                data['subProfile_id'] = this.activeSubProfile._id;
                        
                axios
                    .post(this.FAVORITE_REMOVE, data)
                    .then(() => {
                        this.$store.dispatch("activeSubProfile");    
                        toast.success("Usunięto z ulubionych");      
                        this.isSetFavorite = false;                    
                    })
                    .catch(function(error) {
                        toast.error("Usunięcie z ulubionych nie powiodło się");
                        console.log(error);
                    })
            } else {
                // this.toggleModalFavorites();
                toast.error("Usunięcie z ulubionych nie powiodło się");  
            }

            window.gemius_event('_action_', this.gemiusIdentifier, 'button=favorites-unlike', `SCREEN_HIT=${this.$route.name}`, `NAME=${this.item.title}`);
        },
        hoverHandle() {
            this.isInfoHover = !this.isInfoHover;
        },
        toggleModalInfo() {
            this.isModalInfo = !this.isModalInfo;
        },       
        getSlug(url) {
            return url.substring(url.lastIndexOf("/") + 1) 
        },
        toggleModalFavorites() {
            this.isModalFavorites = !this.isModalFavorites;
            this.$store.dispatch("changeModalBackdrop", this.isModalFavorites);
        },  
        generateName(type) {
            if(type) {
                return type[0].toUpperCase() + type.slice(1).toLowerCase();
            }
            return null;
        },
        selectSubprofile(id) {
            this.subprofileSelectedByParent = id;
        },
        clickHandle() {
            if(this.isAgePrevent) {
                this.isModalUnlock = true;
                this.$store.dispatch("changeModalBackdrop", true);
            }
        },
        closeModalUnlock() {
            this.isModalUnlock = false;
            this.$store.dispatch("changeModalBackdrop", false);
        }
    },
    mounted() {
        window.addEventListener('message', this.receiveMessage);
    }
};
</script>